import React from "react";
import pub1 from "../../assets/images/ads/pub1.png";
import pub2 from "../../assets/images/ads/pub2.gif";

const ads = [
  {
    id: 1,
    imageUrl: pub1,
    title: "Découvrez nos offres exclusives",
    description: "Profitez des meilleurs taux pour vos transferts internationaux.",
    link: "/offres-exclusives",
  },
  {
    id: 2,
    imageUrl: pub2,
    title: "Rejoignez notre programme fidélité",
    description: "Gagnez des points à chaque transaction et bénéficiez d’avantages.",
    link: "/programme-fidelite",
  },
];

export default function AdvertisementSection() {
  return (
    <section
      className="rounded-2xl border border-black/5 dark:border-white/10
                 bg-white dark:bg-slate-900 shadow-sm p-5"
    >
      <div className="flex items-center justify-between">
        <h3 className="text-base font-semibold text-slate-900 dark:text-white">
          Offres & nouveautés
        </h3>
      </div>

      <div className="mt-4 space-y-4">
        {ads.map((ad) => (
          <a
            key={ad.id}
            href={ad.link}
            className="group block overflow-hidden rounded-2xl border border-black/5 dark:border-white/10 bg-white dark:bg-slate-950"
          >
            <div className="relative">
              <img
                src={ad.imageUrl}
                alt={ad.title}
                className="h-40 w-full object-cover group-hover:scale-[1.02] transition-transform"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
              <div className="absolute bottom-3 left-3 right-3">
                <div className="text-white font-semibold">{ad.title}</div>
                <div className="text-white/80 text-sm line-clamp-2">{ad.description}</div>
              </div>
            </div>

            <div className="flex items-center justify-between px-4 py-3">
              <span className="text-sm font-medium text-blue-600 dark:text-blue-400">
                Voir l’offre
              </span>
              <span className="text-slate-400 dark:text-slate-300">→</span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
